import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {LinkerPayloadLeavingGroupsQuery} from 'molbio/adcs/linker-payload-connection/__generated/LinkerPayloadLeavingGroupsQuery';

export const LINKER_PAYLOAD_INACCESSIBLE_ERROR = "You don't have access to the linker-payload.";
export const LINKER_PAYLOAD_LEAVING_GROUPS_LOOKUP_ERROR =
  "Couldn't look up the linker-payload's leaving groups.";

export const LINKER_PAYLOAD_LEAVING_GROUPS_QUERY = gql`
  query LinkerPayloadLeavingGroupsQuery($moleculeId: StrictString!) @engComponent(name: MOLBIO) @skipAudit {
    molecule(id: $moleculeId) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            leavingGroups {
              ... on LeavingGroupsNode {
                numbers
              }
              ... on ErrorNode {
                message
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export type LinkerPayloadLeavingGroupsResult = {leavingGroups: Array<number>} | {error: string};

/** Reads the leaving groups drawn on a linker-payload molecule's current structure, by number in ascending order. */
export function getLinkerPayloadLeavingGroupsResult({
  molecule,
}: LinkerPayloadLeavingGroupsQuery): LinkerPayloadLeavingGroupsResult {
  if (isInaccessible(molecule)) {
    return {error: LINKER_PAYLOAD_INACCESSIBLE_ERROR};
  }
  const {leavingGroups} = molecule.currentVersion.chemicalStructure;
  return leavingGroups.__typename === 'ErrorNode'
    ? {error: leavingGroups.message}
    : {leavingGroups: leavingGroups.numbers};
}
